import LineHeight2 from '@assets/icons/line-height-2.svg'
import { Icon } from './Icon'

export const LineHeight2Icon = Icon(LineHeight2)
